// extracted by mini-css-extract-plugin
export default {"dropdownTitle":"articlepage_dropdownTitle__+YNKO","scenario":"articlepage_scenario__Tgyb-","button":"articlepage_button__WxRwu"};